import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'shared/components';
import { isRtl } from 'modules/language/selectors/language';
import {
   VideoLayoutManager,
   CallTimer,
   VideoToastsPlace,
} from 'modules/conference/components';

import theme from './VideoSidebar.scss';


const propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isNeedToShowBackButton: PropTypes.bool,
  callerName: PropTypes.string.isRequired,
  consultationStartedTime: PropTypes.number,
  conferenceStarted: PropTypes.bool.isRequired,
  hideAppointmentInfo: PropTypes.func.isRequired,
  isConferenceInProgress: PropTypes.bool.isRequired,
};

const defaultProps = {
  consultationStartedTime: undefined,
  isNeedToShowBackButton: false,
};

const VideoSidebar = ({
  intl,
  isMobile,
  callerName,
  conferenceStarted,
  hideAppointmentInfo,
  isConferenceInProgress,
  isNeedToShowBackButton,
  consultationStartedTime,
}) => (
  <div className={ theme.root }>

    <div className={ theme.header }>
      <div className={ theme.leftContainer }>
        <Choose>
          <When condition={ consultationStartedTime && conferenceStarted }>
            <CallTimer />
          </When>
          <Otherwise>
            <If condition={ isNeedToShowBackButton && !isConferenceInProgress }>
              <button
                data-testid="patient-info-sidebar-back-button"
                aria-label={ intl.formatMessage({
                  id: 'General.Back',
                  defaultMessage: '** Back',
                }) }
                className={ theme.backButton }
                onClick={ hideAppointmentInfo }
              >
                <Icon
                  className={ theme.leftContainer }
                  name={ isRtl() ? 'arrow-right' : 'arrow-left' }
                />
              </button>
            </If>
          </Otherwise>
        </Choose>
      </div>

      <div className={ theme.centerContainer }>
        {
          isConferenceInProgress
          ? isMobile
              ? <h2>{ callerName }</h2>
              : <h2>{ intl.formatMessage({ id: 'common.videoSidebar.videoConsultation.title', defaultMessage: '** Video Consultation' }) }</h2>
          : <h2>{ intl.formatMessage({ id: 'common.videoSidebar.waitingRoom.title', defaultMessage: '** Waiting room' }) }</h2>
        }

      </div>

      <div className={ theme.rightContainer } />

    </div>

    <div className={ theme.videoContainer }>
      <VideoToastsPlace containerClassName={ theme.videoToastsPlace } />

      <div className={ theme.content }>
        <VideoLayoutManager />
      </div>
    </div>
  </div>
);

VideoSidebar.propTypes = propTypes;
VideoSidebar.defaultProps = defaultProps;

export default VideoSidebar;
